import PropTypes from "prop-types";

import { IN_PROGRESS, DONE, FAILED } from "commons/src/helpers/RequestHelpers";

export const SAVE_LINKS = "SAVE_LINKS";

export const requestObject = PropTypes.shape({
    status: PropTypes.oneOf([IN_PROGRESS, DONE, FAILED]),
    errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
    errorCode: PropTypes.string,
    severity: PropTypes.string,
    numberOfRetries: PropTypes.number
});

export function start(requestData) {
    return {
        requestData,
        type: IN_PROGRESS
    };
}

export function finish(requestData) {
    return {
        requestData,
        type: DONE
    };
}

export function fail(requestData) {
    return {
        requestName: requestData.requestName,
        severity: requestData.severity,
        error: requestData.error,
        errorMessage: requestData.errorMessage,
        errorCode: requestData.errorCode,
        type: FAILED
    };
}

export function saveLinks(links) {
    return {
        links,
        type: SAVE_LINKS
    };
}
